const getCost = (cost) => Number(cost.toFixed(2));

export default getCost;
